export const namespaced = true

export const state = {
    currentProperty: {},
    currentPropertyName:'',
    currentPropertyId:0,
    currentReceiptId:0,
}

export const mutations = {
  
    SET_CURRENT_PROPERTY(state, property) {
       state.currentProperty = property
    },
    CLEAR_CURRENT_PROPERTY(state) {
        state.currentProperty = null
     },
     SET_CURRENT_PROPERTY_NAME(state, propertyName) {
        state.currentPropertyName = propertyName
     },

     CLEAR_CURRENT_PROPERTY_NAME(state) {
        state.currentPropertyName = ''
     },

     SET_CURRENT_PROPERTY_ID(state, propertyId) {
        state.currentPropertyId = propertyId
     },

     CLEAR_CURRENT_PROPERTY_ID(state) {
        state.currentPropertyId = 0
     },

     SET_CURRENT_RECEIPT_ID(state, receiptId) {
        state.currentReceiptId = receiptId
     },

     CLEAR_CURRENT_RECEIPT_ID(state) {
        state.currentReceiptId = 0
     },
}